import { config } from '@/utils/config';

export const mainRouting = [
  {
    routeName: 'card',
    icon: 'mdi-card-account-details-outline',
    title: 'Karta',
    text: 'Twoja elektroniczna karta mieszkańca'
  },
  {
    routeName: 'partners',
    icon: 'mdi-account-multiple',
    title: 'Partnerzy',
    text: 'Zobacz listę firm współpracujących z serwisem Karta Miejska'
  },
  {
    routeName: 'events',
    icon: 'mdi-cards-outline',
    title: 'Usługi',
    text: 'Wszystkie aktywne i zbliżające się oferty oraz promocje'
  },
  {
    routeName: 'history',
    icon: 'mdi-history',
    title: 'Historia',
    text: 'Historia twojej aktywności'
  }
];

/**
 * Wyliczanie dostępnego routingu dla włączonych modułów
 *
 * @export
 * @return {Array<{ routeName: string; icon: string; title: string; text: string }>}
 */
export function routing(): Array<{ routeName: string; icon: string; title: string; text: string }> {
  const routing = [...mainRouting];
  if (config.modules.points) {
    routing.splice(3, 0, {
      routeName: 'containerPoints',
      icon: 'mdi-star-circle',
      title: 'Moje punkty',
      text: 'System zbierania punktów'
    });
  }

  return routing;
}
